import { ETowerOption } from '../contracts-and-constructions/types';

// Action Types
export enum Types {
  LOAD_CONTRACTS = 'fabricationContracts/LOAD_CONTRACTS',
  LOAD_CONTRACTS_SUCCESS = 'fabricationContracts/LOAD_CONTRACTS_SUCCESS',
  LOAD_CONTRACTS_FAILURE = 'fabricationContracts/LOAD_CONTRACTS_FAILURE',

  LOAD_CONTRACTS_V2 = 'fabricationContracts/LOAD_CONTRACTS_V2',

  LOAD_CONTRACT_DETAILS = 'fabricationContracts/LOAD_CONTRACT_DETAILS',
  LOAD_CONTRACT_DETAILS_V2 = 'fabricationContracts/LOAD_CONTRACT_DETAILS_V2',
  LOAD_CONTRACT_DETAILS_SUCCESS = 'fabricationContracts/LOAD_CONTRACT_DETAILS_SUCCESS',
  LOAD_CONTRACT_DETAILS_FAILURE = 'fabricationContracts/LOAD_CONTRACT_DETAILS_FAILURE',

  LOAD_CONTRACT_BY_CONTRACT_NUMBER = 'fabricationContracts/LOAD_CONTRACT_BY_CONTRACT_NUMBER',
  LOAD_CONTRACT_BY_CONTRACT_NUMBER_V2 = 'fabricationContracts/LOAD_CONTRACT_BY_CONTRACT_NUMBER_V2',
  LOAD_CONTRACT_BY_CONTRACT_NUMBER_SUCCESS = 'fabricationContracts/LOAD_CONTRACT_BY_CONTRACT_NUMBER_SUCCESS',
  LOAD_CONTRACT_BY_CONTRACT_NUMBER_FAILURE = 'fabricationContracts/LOAD_CONTRACT_BY_CONTRACT_NUMBER_FAILURE',

  CLEAR_FABRICATION_CONTRACTS = 'fabricationContracts/CLEAR_FABRICATION_CONTRACTS'
}

export interface IFabricationContractState {
  contracts?: IFabricationContract[];
  selectedContract?: IFabricationContract;
  loading: boolean;
  error: boolean;
  updatedAt?: number;
  contractError?: boolean;
}

// CONTRATOS
export interface IFabricationContract extends IFabricationContractDetails {
  contractNumber: string;
  customerOrder: string;
  creationDate: string;
  soldTo: IContractCustomer;
  shipTo: IContractCustomer;
  status: EFabricationContractsStatus;

  loadingDetails?: boolean;
  errorDetails?: boolean;
}
export interface IFabricationContractDetails {
  division?: string;
  divisionDescription?: string;
  location?: string;
  requestedDate?: string;
  entryOrders?: number;
  logistic?: IConstructionLogistic;
  lastOrderNumber?: string;
  lastOrderDetails?: ILastOrderDetails[];

  annealedWireType?: [{ annealedWireId: string }];
}

export enum EFabricationContractsStatus {
  ALL = 'Todos',
  OPEN = 'Aberto',
  CLOSED = 'Encerrado',
  NEW_CONTRACT = 'Novo contrato'
}
interface IConstructionLogistic {
  contractNumber: string | null;
  vehicleType: EVehicleTypes[];
  dischargeType: EDischargeTypes;
  dischargeObservation: string;
  towers: string[];
  towerOption: ETowerOption;
  isSingleTower: boolean;
  schedules: IDayAndTimeToReceive[];
  responsiblesOfConstruction: IResponsibleOfConstruction[];
}

export enum EVehicleTypes {
  CARRETA = 'Carreta (25t)',
  CAMINHAO_TRUCK = 'Caminhão Truck'
  // CAMINHAO_MUNCK="Caminhão munck",
}

export enum EDischargeTypes {
  MANUAL = 'Manual',
  MECHANIZED = 'Mecanizada'
}

export interface IDayAndTimeToReceive {
  checked?: boolean;
  day: EWeekDays;
  startTime?: string;
  endTime?: string;
}

export enum EWeekDays {
  MONDAY = '1',
  TUESDAY = '2',
  WEDNESDAY = '3',
  THURSDAY = '4',
  FRIDAY = '5',
  SATURDAY = '6',
  SUNDAY = '7'
}

export interface IResponsibleOfConstruction {
  name: string;
  email: string;
  phoneNumber: string;
  jobTitle: string;
  key?: number;
}

export interface IContractCustomer {
  code: string;
  name: string;
  taxNumber?: string;
  taxState?: string;
  address?: string;
  city?: string;
  state?: string;
  zipCode?: string;
}

export interface ILastOrderDetails {
  id: number;
  contractNumber: string;
  orderNumber: string;
  sendDate: string;
}
